import { Alert, Box, Loader, Title } from '@mantine/core';

import { useParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { useUser } from '../hooks/useUser';
import { UserForm } from '../components/UserForm';

export const EditUser = () => {
  const { id } = useParams();
  const auth = useAuth();
  const { user, error } = useUser(auth?.token, id);

  if (!id) {
    return <Alert color="red">Could not load user</Alert>;
  }

  return error ? (
    <Alert color="red">{error}</Alert>
  ) : user ? (
    <Box>
      <Title order={3} mb={12}>
        Edit User {user.username}
      </Title>
      <UserForm user={user} />
    </Box>
  ) : (
    <Loader />
  );
};
